import { render, staticRenderFns } from "./HistoricalDetails.vue?vue&type=template&id=5ce31d2a&scoped=true"
import script from "./HistoricalDetails.vue?vue&type=script&lang=js"
export * from "./HistoricalDetails.vue?vue&type=script&lang=js"
import style0 from "./HistoricalDetails.vue?vue&type=style&index=0&id=5ce31d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce31d2a",
  null
  
)

export default component.exports